import { Modal, Form, DatePicker, Button } from "antd";
import { useState } from "react";
import { FontFa } from "../../../../../../../components";
import { UploadVPCT } from "./upload-file-vpct";

export interface UpdateFieldsModalProps {
  visible: boolean;
  onClose: () => void;
  onUpdate: (values: UpdateFieldsValues) => void;
  defaultValue: any;
}

export interface UpdateFieldsValues {
  expiredDate: moment.Moment;
  otherPhoto: any[];
}

const UpdateFieldsModal: React.FC<UpdateFieldsModalProps> = ({ visible, onClose, onUpdate, defaultValue }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      onUpdate(values);
      form.resetFields();
      onClose();
    } catch (error) {
      console.error("Validation failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Cập nhật thông tin cấp thẻ KSAN"
      open={visible}
      onCancel={onClose}
      onOk={handleOk}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" defaultValue={defaultValue}>
        {/* Expired Date */}
        <Form.Item name="expiredDate" label="Ngày đến hạn">
          <DatePicker style={{ width: "100%" }} placeholder="Chọn ngày" bordered format="DD/MM/YYYY" />
        </Form.Item>

        {/* Upload Other Photos */}
        <Form.Item
          name="otherPhoto"
          label="Hình ảnh khác"
          valuePropName="fileList"
          getValueFromEvent={(e) => e?.fileList}
        >
          <UploadVPCT multiple listType="picture" beforeUpload={() => false}>

            <Button
              shape="round"
              type="primary"
              className="mx-1"
              icon={<FontFa className="mr-2" name="faCloudUploadAlt" />}
            >
              Upload hình ảnh
            </Button>
          </UploadVPCT>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateFieldsModal;
